var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "TcLogin h-full" }, [
    _c("div", { staticClass: "container mx-auto h-full" }, [
      _c(
        "div",
        {
          staticClass:
            "flex flex-col gap-6 justify-center content-center mx-auto max-w-2xl h-full"
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.username,
                expression: "username"
              }
            ],
            staticClass: "input-login",
            attrs: {
              type: "text",
              name: "uno",
              placeholder: "Usuario",
              autocomplete: "off"
            },
            domProps: { value: _vm.username },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.username = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password"
              }
            ],
            staticClass: "input-login",
            attrs: {
              type: "password",
              name: "dos",
              placeholder: "Contraseña",
              autocomplete: "off"
            },
            domProps: { value: _vm.password },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.password = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("button", { staticClass: "mt-8", on: { click: _vm.login } }, [
            _vm._v("Continuar")
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }